import { ChatMembersType } from "./store";

export enum ChatType {
      MESSAGES = 'MESSAGES',
      CHAT_LIST = 'CHAT_LIST'
}

export interface IWebComponentProps {
      token?: string | null;
      // Main-platform JWT used to authenticate the separate file service
      // (uploads). Optional — falls back to `token` when not provided.
      serviceToken?: string | null;
      user?: any;
      // Deep link: open this conversation on load (e.g. from an FCM push).
      // `selectChatId` is the chat_id (group id, or the other user's id for a
      // direct chat); `selectChatType` disambiguates the two.
      selectChatId?: string | null;
      selectChatType?: 'direct' | 'group' | null;
      type?: ChatType.MESSAGES | ChatType.CHAT_LIST;
      onRegisterStartChat?: (fn: (userId: number) => void) => void;
      modalContainer?: HTMLElement | null;
      dropdownContainer?: HTMLElement | null;
      onResetUnread?: (status: number) => void;
      onLoading?: (status: null) => void;
      onViewProfile?: (agentId: ChatMembersType | null) => void;
      onOpenStory?: (storyHashkey: string) => void;
}